import $ from "cash-dom";
// import "../components/pv-logger";

$(function () {
	function closeAllDropdowns() {
		$(".nav-item.dropdown.active").removeClass("active");
		$(".nav-item.dropdown .sub-menu.active").removeClass("active");
		$(".nav-item.dropdown > a.nav-link.dropdown-toggle").attr("aria-expanded", "false");
		$(".nav-item.with-super-categories > .sub-menu").each(function () {
			this.style.left = "";
			this.style.right = "";
		});
		$(".nav-item.dropdown:not(.with-super-categories) > .sub-menu").each(function () {
			this.style.left = "";
			this.style.right = "";
		});
	}

	// Desktop only: the multi-column (mega) panel is wide, so a static CSS anchor
	// (left:0 / right:0 relative to the trigger) sprawls off-screen depending on
	// where the trigger sits. Measure the trigger + panel and clamp the panel into
	// the viewport: align its left edge under the trigger, then nudge it left/right
	// so it never overflows either edge.
	function positionDropdown($container) {
		var li = $container.get(0);

		if (!li) {
			return;
		}

		var submenu = $container.children(".sub-menu").get(0);

		if (!submenu) {
			return;
		}

		// Mobile: panel is in normal flow — drop any desktop inline positioning.
		if (window.innerWidth < 1023) {
			submenu.style.left = "";
			submenu.style.right = "";
			return;
		}

		var margin = 8;

		// Normalize before measuring so a previous run doesn't skew the geometry.
		submenu.style.right = "auto";
		submenu.style.left = "0px";

		var triggerRect = li.getBoundingClientRect();
		var menuWidth = submenu.offsetWidth;
		var viewportWidth = document.documentElement.clientWidth;
		var desiredLeft = triggerRect.left;

		if (desiredLeft + menuWidth > viewportWidth - margin) {
			desiredLeft = viewportWidth - margin - menuWidth;
		}

		if (desiredLeft < margin) {
			desiredLeft = margin;
		}

		submenu.style.left = Math.round(desiredLeft - triggerRect.left) + "px";
		submenu.style.right = "auto";
	}

	function clearDropdownPosition($container) {
		var submenu = $container.children(".sub-menu").get(0);

		if (submenu) {
			submenu.style.left = "";
			submenu.style.right = "";
		}
	}

	$("#mobile-nav-toggle").on("click", function (e) {
		e.preventDefault();

		$("#main-navigation, #mobile-nav-toggle").toggleClass("active");
		$("#main-navigation").toggleClass("open");

		closeAllDropdowns();

		var navOpen = $("#main-navigation").hasClass("open");
		$("#mobile-nav-toggle").attr("aria-expanded", navOpen ? "true" : "false");

		var paddingTop = $("#mobile-nav-toggle").get(0).offsetTop + 30;

		$(".main-navigation-block").css("padding-top", paddingTop + "px");
	});

	$(".nav-links > ul.navbar-nav > li.nav-item.dropdown > a.nav-link.dropdown-toggle").on("click", function (e) {
		e.stopPropagation();

		if ($(e.target).closest(".dropdown-toggle").get(0) !== $(this).get(0)) {
			return;
		}

		e.preventDefault();

		var $toggler = $(this),
			$container = $toggler.parent(),
			$submenu = $container.children(".sub-menu");

		$container.siblings(".dropdown.active").each(function () {
			if ($(this).get(0) !== $container.get(0)) {
				$(this).removeClass("active");
				$(this).children(".sub-menu").removeClass("active");
				$(this).children("a.nav-link.dropdown-toggle").attr("aria-expanded", "false");
				clearDropdownPosition($(this));
			}
		});

		$container.toggleClass("active");
		$submenu.toggleClass("active");

		var isOpen = $container.hasClass("active");
		$toggler.attr("aria-expanded", isOpen ? "true" : "false");

		if (isOpen) {
			positionDropdown($container);
		} else {
			clearDropdownPosition($container);
		}
	});

	// only the top level is bound above; every other template keeps the shared behaviour of
	// expanding the nested panels outright
	$(".nav-links .sub-menu .nav-item.dropdown > a.nav-link.dropdown-toggle").on("click", function (e) {
		if (!document.body.classList.contains("design-template-5") || window.innerWidth >= 1200) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		var $container = $(this).parent();

		$container.siblings(".dropdown.active").removeClass("active");
		$container.toggleClass("active");
		$(this).attr("aria-expanded", $container.hasClass("active") ? "true" : "false");
	});

	// Ensure toggles expose an initial closed state for assistive tech.
	$(".nav-links > ul.navbar-nav > li.nav-item.dropdown > a.nav-link.dropdown-toggle").attr("aria-expanded", "false");

	$(document).on("click", function (e) {
		if (!$(e.target).closest(".nav-item.dropdown").length) {
			closeAllDropdowns();
		}
	});

	$(".nav-link.dropdown-toggle").on("mouseenter", function () {
		$(".simple-tooltip").remove();
	});

	$(window).on("resize", function () {
		if (window.innerWidth > 1023) {
			$(".main-navigation-block").removeAttr("style");
		}
		closeAllDropdowns();
	});

	$(window).on("scroll", function () {
		// Close the menu when the page is scrolled/slid (desktop and mobile). The
		// mobile menu scrolls internally (capped height + overflow-y:auto in CSS),
		// so navigating a long menu does not fire window scroll and keeps it open;
		// only scrolling the underlying page closes it.
		if ($(".nav-item.dropdown.active").length || $("#main-navigation").hasClass("open")) {
			$("#main-navigation, #mobile-nav-toggle").removeClass("active");
			$("#main-navigation").removeClass("open");
			$("#mobile-nav-toggle").attr("aria-expanded", "false");
			closeAllDropdowns();
		}
	});

	document.addEventListener("click", function (e) {
		var $menu = $("#main-navigation");
		if ($menu.hasClass("open")) {
			var isClickInsideMenu = $(e.target).closest("#main-navigation").length > 0;
			var isClickOnToggle = $(e.target).closest("#mobile-nav-toggle").length > 0;

			if (!isClickInsideMenu && !isClickOnToggle) {
				// Stop the click event completely so it doesn't trigger links, clickouts, popups, etc.
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				// Close the menu
				$menu.removeClass("open active");
				$("#mobile-nav-toggle").removeClass("active").attr("aria-expanded", "false");
				closeAllDropdowns();
			}
		}
	}, true); // Use capture phase to intercept click before it triggers other elements
});
